import { FormEvent, useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../store/modules/auth/actions'
import { initialMenu, selectedMenu } from '../../store/modules/menu/actions'
import { cercDeleteAllURs } from '../../store/modules/cerc/actions'
import { StoreState } from '../../store'
import { Popover } from '@headlessui/react'
import {
    MdKeyboardArrowRight,
    MdOutlineHelpOutline,
    MdOutlineLogout,
} from 'react-icons/md'
import { UserProfile, PopoverMenu, Avatar } from './styles'
import { BsFileEarmark, BsFileEarmarkText } from 'react-icons/bs'
import { HiOutlineNewspaper } from 'react-icons/hi'
import Adesao from '../TermosCondicoes/Adesao'
import Dialog from '../../components/Dialog'
import Politica from '../TermosCondicoes/Politica'
import CondicoesGerais from '../TermosCondicoes/CondicoesGerais'

export default function MenuPopover() {
    const dispatch = useDispatch()
    const { email, empresa } = useSelector(
        (state: StoreState) => state.auth.user
    )
    const [isTermsOpen, setIsTermsOpen] = useState(false)
    const [title, setTitle] = useState('')
    const [Termo, setTermo] = useState<React.ReactElement | React.ReactNode>()
    function handleClick(
        element: React.ReactElement | React.ReactNode,
        title: string
    ) {
        setIsTermsOpen(true)
        setTitle(title)
        setTermo(element)
    }

    const handleLogout = (e: FormEvent) => {
        dispatch(actions.loginFailure())
        dispatch(initialMenu())
        dispatch(cercDeleteAllURs())
    }

    // const handleSubmit = async (e: FormEvent) => {
    //     e.preventDefault()
    //     try {
    //         dispatch(cercDeleteAllURs())
    //         await api.post('/agenda', {
    //             cnpj_cpf: cnpj_cpf,
    //         })
    //     } catch (error) {}
    // }
    return (
        <Popover className="popover">
            <Popover.Button>
                <UserProfile>
                    <Avatar>{empresa?.charAt(0).toUpperCase() || 'Z'}</Avatar>
                    <span>{empresa}</span>
                    <MdKeyboardArrowRight color="#333" size={14} />
                </UserProfile>
            </Popover.Button>

            <Popover.Panel>
                <PopoverMenu>
                    <div className="profile">
                        <Avatar />
                        <h1>{empresa}</h1>
                        <Link
                            to="minhaconta"
                            onClick={(e) =>
                                dispatch(
                                    selectedMenu({
                                        mainMenu: 'Minha conta',
                                        subMenu: '',
                                        currentLink: 'minhaconta',
                                    })
                                )
                            }
                        >
                            Minha conta
                        </Link>
                    </div>
                    <button className="email">
                        <Avatar>
                            {empresa?.charAt(0).toUpperCase() || 'Z'}
                        </Avatar>
                        <span>{email}</span>
                    </button>
                    {/* <Link to="" className="msg-notify">
                        <MdOutlineMailOutline size={20} />
                        <span>Mensagens</span>
                        <AlertCircle hasAlert={true}>4</AlertCircle>
                    </Link>
                    <Link to="" className="msg-notify">
                        <MdNotificationsNone size={20} />
                        <span>Notificações</span>
                        <AlertCircle hasAlert={false}></AlertCircle>
                    </Link> */}
                    {/* <form onSubmit={handleSubmit}>
                        <button type="submit" className="link form-button"><MdSwapVert size={18} /><span>Solicitar nova agenda</span></button>
                    </form> */}
                    <button
                        onClick={() =>
                            handleClick(
                                <Politica />,
                                'Política de Privacidade e Proteção de Dados'
                            )
                        }
                        className="link"
                    >
                        <HiOutlineNewspaper size={18} />
                        <span>Politica de Privacidade</span>
                    </button>
                    <button
                        onClick={() =>
                            handleClick(
                                <CondicoesGerais />,
                                'Contrato de Prestacão de Serviço e Licença de Uso de Software'
                            )
                        }
                        className="link"
                    >
                        <HiOutlineNewspaper size={18} />
                        <span>Prestacão de Serviço </span>
                    </button>
                    <button
                        onClick={() =>
                            handleClick(
                                <Adesao />,
                                'Termo de Adesão ao Contrato de Prestação de Serviço e Licença de Uso de Software'
                            )
                        }
                        className="link"
                    >
                        <HiOutlineNewspaper size={18} />
                        <span>Termo de Adesão</span>
                    </button>
                    <Link to="" className="link">
                        <MdOutlineHelpOutline size={18} />
                        <span>Ajuda</span>
                    </Link>
                    <Link to="/login" onClick={handleLogout} className="link">
                        <MdOutlineLogout size={18} />
                        <span>Sair</span>
                    </Link>
                </PopoverMenu>
            </Popover.Panel>
            <Dialog
                isTermsOpen={isTermsOpen}
                setIsTermsOpen={setIsTermsOpen}
                title={title}
            >
                {Termo}
            </Dialog>
        </Popover>
    )
}
